import React from "react";
import { Col,Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom"; 

function AssesmentDashboardRecord() {

        const navigate = useNavigate(); 
        const totalAssesmentRecord = [
        {
            key: "total-educated",
            icon: "school",
            trend: "card_membership",
            title: "Total Educated",
            variant: "blue",
            number:8,
        },
        {
            key: "total-disbaled",
            icon: "accessible",
            trend: "price_change",
            title: "Total Disabled",
            variant: "green",
            number: 3,
        },
        {
            key: "skilled",
            icon: "lightbulb",
            trend: "account_balance_wallet",
            title: "Total Skilled",
            variant: "purple",
            number: 9,
        },
        {
            key: "total-abused",
            icon: "securityoutlined",
            trend: "account_balance_wallet",
            title: "Total Abused",
            variant: "purple",
            number: 4,
        },
      

        
    ];

     const handleCardClick = (key) => {
        navigate(`/assesment-dashboard-list/${key}`);
    };
     const getCardColor = (title) => {
  const lowerTitle = title.toLowerCase();

  if (lowerTitle.includes("distributed")) return "#3399FF"; // Medium Blue
  if (lowerTitle.includes("pending")) return "#FFB84D";     // Medium Orange
  if (lowerTitle.includes("total")) return "#4CAF50";       // Medium Green

  return "red"; // Medium Red for default / not verified
};
    
    return (
        <>
        <div className="card d-flex flex-column mb-4 p-0">
          <div className="card-header m-0"
          style={{backgroundColor:"#077834"}}>
            <h3 className="card-title text-light">Assesment Overview</h3>
          </div>
        
          <Row className="gx-2 gy-2 p-2 ">
            {totalAssesmentRecord.map((data) => {
                            return (
                                <Col md={4} className="mt-2 mb-0">
                                    <div
                                    onClick={handleCardClick}
                                        className={`mc-ecommerce-card `}
                                        style={{
                                            background:
                                                "linear-gradient(to right, rgba(0,0,0,0.8), #077834)",
                                                cursor:"pointer"
                                        }}
                                    >
                                        <i className="mc-ecommerce-card-trend material-icons">
                                            {data.icon}
                                        </i>
                                        <div className="mc-ecommerce-card-head">
                                            <h4 className="mc-ecommerce-card-meta">
                                                <span>{data.title}</span>
                                                {data.number}
                                            </h4>
                                            <i className="mc-ecommerce-card-icon material-icons">
                                                {data.icon}
                                            </i>
                                        </div>
                                        <div className="mc-ecommerce-card-foot">
                                            
                                        </div>
                                    </div>
                                </Col>
                            );
                        })}
          </Row>
        </div>
        
        
        </>
        
    )
}

export default AssesmentDashboardRecord
